import styled from 'styled-components';

export const TableMobile = styled.table`
  th {
    font-size: 8px;
    padding: 1px;
  }

  td {
    font-size: 8px;
    padding: 1px;  
    font-weight: bold;
  }
`;
